import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { APP_BASE_HREF } from '@angular/common';
import { Constants } from '../../shared/Constants';

@Injectable()
export class UserService {

    constructor(private http: HttpClient) { }

    obtenerDatosPersonales() {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

        return this.http.get(Constants.URL_BACKEND + '/HS_Usuario/datosPersonales', { headers: headers });
    }

    getUsuarioByName(nombres) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.get(Constants.URL_BACKEND + '/usuarioFilter?nombres=' + nombres, { headers: headers });
      }

    getUsers() {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    
        return this.http.get(Constants.URL_BACKEND + '/HS_GetUsuario/', { headers: headers });
      }


    getUsersList() {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

        return this.http.get(Constants.URL_BACKEND + '/HS_Usuario', { headers: headers });
    }

    createUser(userData) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

        return this.http.post(Constants.URL_BACKEND + '/HS_Usuario', userData, { headers: headers });
    }

    updateUsers(idUser, updateData) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));

        return this.http.put(Constants.URL_BACKEND + '/HS_Usuario/' + idUser, updateData, { headers: headers });
    }

    deleteUsers(idUser) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.put(Constants.URL_BACKEND + '/HS_Usuario/eliminarUsuario/' + idUser, {}, { headers: headers });
    }

    recoverPassword(email) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.post(Constants.URL_BACKEND + '/HS_Usuario/recuperarPswd', { correo: email }, { headers: headers });
    }

    sendNewPassword(newPass, jwt) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(jwt));
        return this.http.post(Constants.URL_BACKEND + '/HS_Usuario/nuevoPswd', { jwt: newPass }, { headers: headers });
    }

}



// WEBPACK FOOTER //
// ./src/app/system/services/usuario.service.ts